import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'

import HomeImg from '@/assets/img/home.svg'
import { ApplicationState } from '@/state/root.models'
import { colors } from '@/theme/colors.theme'

export const OverviewComponent = () => {
  const { t } = useTranslation()

  const { loggedUser } = useSelector(({ auth }: ApplicationState) => auth)

  return (
    <Box
      sx={{
        background: `linear-gradient(84.98deg, ${colors.primary} 0%, ${colors.darker} 100%)`,
        borderRadius: '16px',
        maxWidth: '856px',
        height: '211px',
        padding: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ maxWidth: '365px' }}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {`${t('messages.homeTitle')}`}
        </Typography>
        <Typography
          variant="h5"
          sx={{ marginBottom: '20px' }}
        >{`${loggedUser.firstName} ${loggedUser.lastName}`}</Typography>
      </Box>
      <img src={HomeImg} alt="Home" />
    </Box>
  )
}
